var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "视频",
        visible: _vm.showDialog,
        "append-to-body": "",
        width: "50%"
      },
      on: {
        "update:visible": function($event) {
          _vm.showDialog = $event
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "video-player-box",
          on: {
            contextmenu: function($event) {
              $event.preventDefault()
            }
          }
        },
        [
          _c("video-player", {
            ref: "videoPlayer",
            staticClass: "video-player vjs-custom-skin",
            attrs: { playsinline: true, options: _vm.playerOptions },
            on: {
              ended: function($event) {
                return _vm.playEnd($event)
              }
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }